import { render, staticRenderFns } from "./FormLogin.vue?vue&type=template&id=4bd930f8&scoped=true&"
import script from "./FormLogin.vue?vue&type=script&lang=ts&"
export * from "./FormLogin.vue?vue&type=script&lang=ts&"
import style0 from "./FormLogin.vue?vue&type=style&index=0&id=4bd930f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd930f8",
  null
  
)

export default component.exports